import React from 'react';
import { Tabs } from '@telus-uds/components-web';

const tabItems = [
  { id: 'COUPON_CODES', label: 'Coupon Codes' },
  { id: 'DEVICE_MATRIX', label: 'Device Matrix' }
];

const TabSelection = ({ selectedTab, setSelectedTab }) => {
  return (
    <div style={{ margin: '2rem 0' }}>
      <Tabs
        value={selectedTab}
        onChange={setSelectedTab}
        items={tabItems}
        itemTokens={{ maxWidth: 'none', borderWidth: 1, borderColor: '#D8D8D8', marginHorizontal: 4 }}
      />
    </div>
  );
};

export default TabSelection;
